const Utils = require('./utils.js')

$(function () {

  // Storing pageCollection function to window so that it can be used in template
  self.pageCollection = Utils.pageCollection;
  const pagedPosts = pageCollection(contentful.blogPosts, 4);
  let currentPage = 0;

  // Since we have configured the reshape loader to be able to load client-side
  // templates out of the `views/templates` directory, we can require this as
  // a javascript template as well as including it in our static views
  const postItemTemplateUS = require('../../views/templates/_postItem.html');
  const postItemTemplateSG = require('../../views/sg/templates/_postItem.html');

  // Blog Index older and newer posts onclick event handlers
  $('button#btn-blog-index-list-older').on('click', () => {
    if (currentPage === pagedPosts.length - 1) return;
    renderPage(++currentPage);
  });

  $('button#btn-blog-index-list-newer').on('click', () => {
    if (currentPage === 0) return;
    renderPage(--currentPage);
  });

  function updateNewerLinkVisibility() {
    if (currentPage == 0) {
      $('button#btn-blog-index-list-newer').hide();
    } else {
      $('button#btn-blog-index-list-newer').show();
    }
  }

  function updateOlderLinkVisibility() {
    if (currentPage == pagedPosts.length - 1) {
      $('button#btn-blog-index-list-older').hide();
    } else {
      $('button#btn-blog-index-list-older').show();
    }
  }

  // Replaces the list with a new template reflecting the new page of blog items
  function renderPage(page) {
    var posts = contentful.blogPosts;

    if (region === 'UnitedStates') {
      $('div.blog-index-list').html(postItemTemplateUS({ posts, page }));
    } else {
      $('div.blog-index-list').html(postItemTemplateSG({ posts, page }));
    }
    updateNewerLinkVisibility();
    updateOlderLinkVisibility();
  }

  updateNewerLinkVisibility();
  updateOlderLinkVisibility()

});



// WEBPACK FOOTER //
// ./assets/js/blogIndex.js